"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Difficulty = exports.EventType = exports.ActionType = exports.Phase = exports.PLAYERS = exports.Rank = exports.SUITS = exports.Suit = void 0;
var Suit;
(function (Suit) {
    Suit["CLUBS"] = "clubs";
    Suit["DIAMONDS"] = "diamonds";
    Suit["HEARTS"] = "hearts";
    Suit["SPADES"] = "spades";
})(Suit || (exports.Suit = Suit = {}));
exports.SUITS = [Suit.CLUBS, Suit.DIAMONDS, Suit.HEARTS, Suit.SPADES];
var Rank;
(function (Rank) {
    Rank[Rank["NINE"] = 9] = "NINE";
    Rank[Rank["TEN"] = 10] = "TEN";
    Rank[Rank["JACK"] = 11] = "JACK";
    Rank[Rank["QUEEN"] = 12] = "QUEEN";
    Rank[Rank["KING"] = 13] = "KING";
    Rank[Rank["ACE"] = 14] = "ACE";
})(Rank || (exports.Rank = Rank = {}));
exports.PLAYERS = [0, 1, 2, 3];
var Phase;
(function (Phase) {
    Phase["READY"] = "ready";
    Phase["BIDDING"] = "bidding";
    Phase["DISCARD"] = "discard";
    Phase["PLAYING"] = "playing";
    Phase["HAND_OVER"] = "hand_over";
    Phase["GAME_OVER"] = "game_over";
})(Phase || (exports.Phase = Phase = {}));
var ActionType;
(function (ActionType) {
    ActionType["DEAL"] = "deal";
    ActionType["PASS"] = "pass";
    ActionType["ORDER_UP"] = "order_up";
    ActionType["CALL_TRUMP"] = "call_trump";
    ActionType["DISCARD"] = "discard";
    ActionType["PLAY_CARD"] = "play_card";
})(ActionType || (exports.ActionType = ActionType = {}));
var EventType;
(function (EventType) {
    EventType["DEAL_EXECUTED"] = "DEAL_EXECUTED";
    EventType["BID_MADE"] = "BID_MADE";
    EventType["TRUMP_CHOSEN"] = "TRUMP_CHOSEN";
    EventType["CARD_DISCARDED"] = "CARD_DISCARDED";
    EventType["CARD_PLAYED"] = "CARD_PLAYED";
    EventType["TRICK_COMPLETED"] = "TRICK_COMPLETED";
    EventType["TURN_CHANGED"] = "TURN_CHANGED";
    EventType["HAND_COMPLETED"] = "HAND_COMPLETED";
    EventType["GAME_OVER"] = "GAME_OVER";
    EventType["ACTION_REJECTED"] = "ACTION_REJECTED";
})(EventType || (exports.EventType = EventType = {}));
var Difficulty;
(function (Difficulty) {
    Difficulty["EASY"] = "easy";
    Difficulty["MEDIUM"] = "medium";
    Difficulty["HARD"] = "hard";
})(Difficulty || (exports.Difficulty = Difficulty = {}));
